Ext.define('SA.view.MessageWindow', {
    alias: 'widget.message-window',
    extend: 'Ext.Component',

    baseCls: 'sa-message-window',
    floating: true,
    width: 300,

    initComponent() {
        this.html = Ext.util.Format.nl2br(Ext.util.Format.htmlEncode(this.msg));
        this.ui = this.ui || 'default';
        this.mouseOver = false;
        this.fadeDuration = 500;
        this.messageDuration = this.duration || 3000;

        this.callParent();
    },

    fadeInAtBottom(bottom) {
        this.render(Ext.getBody());
        this.show();

        this.setPosition({
            x: 8,
            y: bottom - 8 - this.getHeight()
        });

        this.el.setOpacity(0);
        this.el.fadeIn({duration: this.fadeDuration});
    },

    fadeOut() {
        this.el.fadeOut({
            duration: this.fadeDuration,
            callback: () => this.destroy()
        });
    },

    initEvents() {
        this.callParent();

        this.el.on('mouseover', this.onMouseOver, this);
        this.el.on('mouseout', this.onMouseOut, this);

        this.on('boxready', () => setTimeout(() => this.maybeFadeOut(), this.messageDuration));
    },

    maybeFadeOut() {
        if (this.mouseOver) {
            setTimeout(() => this.maybeFadeOut(), 250);
            return;
        }

        this.fadeOut();
    },

    onMouseOver() {
        this.mouseOver = true;
    },

    onMouseOut() {
        this.mouseOver = false;
    }
});
